module.exports = __webpack_public_path__ + "img/968.924db0f3.png";